import React, { Component } from 'react';
import '../../../sass/components/_modal.scss';

export default class PostProductionJsonModal extends Component {
  render() {
    const {
      // selectedState,
      updateShowPostProductionJsonModal,
      isShowPostProductionJsonModal,
      // function
      saveJson,
    } = this.props;
    return (
      <div className={isShowPostProductionJsonModal ? "modal fade show d-flex" : "modal fade show"}
        id="PostProductionJsonModal" tabIndex="-1" aria-labelledby="loginErrorModalLiveLabel" aria-modal="true" role="dialog"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          // updateShowPostProductionJsonModal(false)
        }}>
        <div className="modal-dialog modal-md">
          <div className="modal-content load-design">
            <div className="modal-header">
              <h5 className="modal-title" id="loginErrorModalLabel">紀錄設計編號</h5>
              <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close"
                onClick={(e) => updateShowPostProductionJsonModal(false)}
              >
              </button>
            </div>
            <div className="modal-body">
              {/* <p>請輸入您的專屬設計編號</p> */}
              <div className="input-group mb-3">
                <p>
                  請記下你的專屬設計編號, 便可以使用此編號在線上規劃重新開啟你的設計。
                </p>
                <input type="text" className="form-control" id="resultCode" defaultValue={saveJson} disabled readOnly />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
